import { render } from "./ListeTypeActeur.vue?vue&type=template&id=2c2303ae&ts=true"
import script from "./ListeTypeActeur.vue?vue&type=script&lang=ts"
export * from "./ListeTypeActeur.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__